// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {

    $(document).ready(function () {            

       // $.components.registerComponent('.why-velux', function ($root) {
        $.each($(document.querySelectorAll('.why-velux')), function () {
            var $root = $(this);

            var WhyVELUX = {
                dom: {
                    base: $root,
                    section: $root.closest('section'),
                    intro: $root.find('.why-velux-intro'),
                    tabs: $root.find('.why-velux-tabs'),
                    tabComponent: $root.find('.tabComponent'),
                    tab: $root.find('.why-velux-tabs > ul > li'),
                    tabContent: function (target) { return $dom.activeTab.find('.tab-content'); },
                    activeTab: null

                },
                set: {
                    speed: 400,
                    animation: 'linear',
                    sleep: 0,
                    sliding: false,
                    activeClass: 'opened',
                    isFullWidth: false
                },
                fn: {
                    slideTabs: function () {
                        /* Only slide the tabs when not on mobile view */
                        if ($(window).width() >= 768 && !$dom.base.hasClass("window-specs")) {

                            $set.sleep = $set.speed * 1.5;

                            if (!$dom.intro.is(':visible')) {
                                $dom.intro.show().fadeIn($set.speed);
                                $dom.tabs.animate({ width: '50%' }, $set.speed);
                            } else {
                                $dom.intro.fadeOut($set.speed, function () { $(this).hide(); });
                                $dom.tabs.animate({ width: '100%' }, $set.speed);
                            }
                        }
                    },
                    openTab: function () {
                        /* Prevent functionality when elements are currently animating */
                        if ($set.sliding) {
                            return;
                        }
                        $set.sliding = true;
                        $set.sleep = 0;

                        /* Check to see if there are no tabs opened, then also slide tabs over left area */
                        if ($dom.tab.filter('.' + $set.activeClass).length == 0 && !$set.isFullWidth) {
                            $fn.slideTabs();
                        } else {
                            /* Close the opened tab the same time the new one is opened */
                            $fn.closeTab();
                        }

                        /* Only open tab if it's not currently opened */
                        if (!$dom.activeTab.hasClass($set.activeClass)) {
                            /* Open the active tab */
                            setTimeout(function () {
                                $dom.tabContent().slideDown($set.speed, $set.animation, function () {
                                    $dom.activeTab.addClass($set.activeClass);
                                    /* Check if open tab is NOT in the viewport, then schroll to it */
                                    if ($dom.activeTab.offset().top < $(window).scrollTop()) {
                                        $('html, body').animate({ scrollTop: $dom.activeTab.offset().top }, $set.speed);
                                    }
                                    $set.sliding = false;
                                });
                            }, $set.sleep);
                        } else {
                            if (!$set.isFullWidth) {
                                setTimeout(function () {
                                    $fn.slideTabs();
                                }, $set.speed);
                            }

                        }
                    },
                    closeTab: function () {
                        $dom.tabs.find('.' + $set.activeClass + ' .tab-content').slideUp($set.speed, $set.animation, function () {
                            $dom.tab.removeClass($set.activeClass);
                            $set.sliding = false;
                        });
                    },
                    openTabBasedOnHash: function () {
                        if (!window.location || !window.location.hash) { return; }
                        var anchorTag = window.location.hash;
                        var anchorTagInDom = $dom.tabs.find('a' + anchorTag);

                        if (anchorTagInDom.length > 0) {
                            $dom.activeTab = anchorTagInDom.next();
                            $fn.openTab();
                        }
                    },
                    addTracking: function () {

                        if ($set.isFullWidth) {
                            var event = {
                                event: "interactionevent",
                                eventcategory: "Accordion",
                                eventaction: "click",
                                eventlabel: $dom.activeTab.find(".tab-title").text().replace(/\n|\r/g, "").trim()
                            };
                            window.dataLayer.push(event);

                        }
                    },
                }
            },
                /* Add quick access variables to be used in local function
                 * Keep main variable name in case it needs to be shared with other JS files
                 */
                $dom = WhyVELUX.dom,
                $set = WhyVELUX.set,
                $fn = WhyVELUX.fn;

            /*if this is tab component, there is no animation*/
            if ($dom.tabComponent.length > 0) {
                $set.speed = 1;
            }
            if ($dom.section.hasClass("full-width")) {
                $set.isFullWidth = true;
            }
            $fn.openTabBasedOnHash();
            window.addEventListener("hashchange", function () {
                $fn.openTabBasedOnHash();
            });

            $dom.tab.on({
                click: function () {
                    $dom.activeTab = $(this).closest('li');
                    $fn.openTab();
                    $fn.addTracking();
                }
            }, '.tab-title');
        }) 

    });

})(window, document, jQuery);